import type { FaireProductEntity } from "../../entity_types/product";

export const p_fjyrz69n6v: FaireProductEntity = {
  token: "p_fjyrz69n6v",
  type: "product",
  name: "Clem Clam the Class Clown",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/1d884bf012e65775976dce3e7b4cc2837396a3743a47380590d14051f492d922.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/38153b1945412311b2bcadf9832c28523c0c534214aabae0d879913fbef5341e.jpeg",
    "https://cdn.faire.com/fastly/f724b86e281dd7b7d7192563529c090d3eee3fa9423676988164054340f99703.jpeg",
    "https://cdn.faire.com/fastly/0acad324b1109b011a17a89c3a9bee86b047548f1a837993e1221d10b2df54ba.jpeg",
    "https://cdn.faire.com/fastly/158f1ac6158ab5d40f87c8873ed3f9a283f483164d8eb879def569af31956f75.jpeg",
    "https://cdn.faire.com/fastly/d07910bbd6a40e803e86fe7e6977302806fd1e878081b7b05c7cea952f0480dc.jpeg",
    "https://cdn.faire.com/fastly/e716d0097aa70951c5d457a1d7ad7bb148273f7fc521bb9a0f49c7c6971a3c58.jpeg",
    "https://cdn.faire.com/fastly/7e15e102a9b5b522ac53c8a228d4ba208f8a7a3325f4fdb15758644afea370a4.jpeg"
  ],
  priceDollars: 9.5,
  description: "A hilarious and encouraging school story about an aspiring class clown, from the bestselling and beloved creator of Arnie, the Doughnut. Clem has always been shy and quiet. He only ever feels comfortable making noise when he’s playing his clarinet. Clem wishes he could be carefree and likeable like Clarence, the funniest clam at school. But one day, to his class’s surprise, Clarence moves away. In no time at all Clem hatches a plan to take his place as the class clown so he can gain popularity, friends, and all-around clam-tastic greatness. Can it be done?! Here is Laurie Keller at her very best with an irrepressible character who moves out of his comfort zone to seek class fame. Little does he know his true talents are closer than he thinks!",
  tags: [],
  msrpDollars: 18.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:07.423Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
